en:
  pages:
    account_management: Account management
    admin: Administration
    all_titles: All titles
    analytics: Analytics
    anomaly_report: Anomaly report
    changelog: Changelog
    ch_export: Data Hub
    configuration: Configuration
    content: Content
    create_report: Create report
    dashboard: Dashboard
    data_coverage_overview: Data coverage overview
    data_management: Data management
    event_preferences: Event preferences
    events: Events
    exports: Exports
    flexi_report: Report detail
    flexi_reports: Reports
    flexitable: Reporting and exports
    heatmap: Interest heatmap
    import_batches: Import batches
    interest_overview: Interest overview
    item_detail: Item detail
    maintenance: Maintenance
    management: Management
    management_commands: Management commands
    manual_data_uploads: Manual data uploads
    mdu_detail: Manual data upload detail
    organization_administration: Organization administration
    organizations: Organizations
    overlap_analysis_platforms: Platform overlap
    overlap_analysis_titles: Titles on multiple platforms
    platform_detail: Platform detail
    platforms: Platforms
    releases: Releases
    settings: Settings
    specialized_reports: Specialized reports
    subscriptions: Overlap analysis
    supported_non_counter_platforms: non-SUSHI platforms
    sushi: SUSHI
    sushi_fetch_attempts: SUSHI harvests
    sushi_management: SUSHI management
    sushi_monthly_overview: SUSHI status
    sushi_troubleshooting: Troubleshooting
    tag_management: Tag management
    tags: Tags
    title_detail: Title detail
    title_list_overlap: Title list overlap
    title_lists: Title lists
    user_page: User page
    whats_new: What's new
    user_management: User management
    counter_registry: COUNTER Registry
  menu: Menu
  organization: Organization
  platform: Platform
  title: Title
  report: Report
  month: Month
  year: Year
  title_fields:
    access_level: Visibility
    actions: Actions
    active_reports: Active reports
    contains_data: Contains data
    counter_version: COUNTER version
    created: Created
    data_coverage: Data coverage
    data_file: Data file
    doi: DOI
    download_success: Download successful
    eissn: eISSN
    enabled: Enabled
    end_date: End date
    error_code: Error code
    id: ID
    info: Info
    isbn: ISBN
    issn: ISSN
    issn_l: ISSN-L
    knowledgebase: Knowledgebase
    last_modified: Last modified
    last_modified_by: Last modified by
    lock: Lock
    log: Log
    name: Name
    non_counter: Non-COUNTER
    not_before: Cannot start until
    organizations: Organizations
    outside_consortium: Outside consortium
    platform_count: Platform count
    platforms: Platforms
    primary_dimension: Rows
    primary_dimensions: Rows
    processed: Imported
    processing_success: Processing successful
    proprietary_ids: Proprietary IDs
    proprietary_ids_tt: Internal title identifiers used by individual platforms/publishers
    publication_date: Publication date
    queued: Queued
    ratios: Ratio
    report_types: Report types
    reports: Reports
    select_platform: Select platform
    short_name: Short name
    split_by: Split by
    start_date: Start date
    status: Status
    success: Success
    total_interest: Total interest
    type: Type
    uploaded: Uploaded
  titles: Titles
  overview: Overview
  chart:
    count: Count
  date_range:
    all_available: All available
    current_plus_1y_back: This and previous year
    current_plus_2y_back: This and two previous years
    custom: Custom
    last_2_closed_fy: Last two closed fiscal years
    last_12_mo: Last 12 months
    last_closed_fy: Last closed fiscal year
    ongoing_and_previous_fy: Ongoing and previous fiscal year
    ongoing_fy: Ongoing fiscal year
    previous_2_years: Last two finished years
    previous_year: Previous year
    current_year: Current year
  date_range_desc:
    current_plus_2y_back: Matches the COUNTER data retention period
    custom: Manually select the data range
  labels:
    accesslog_count: Log count
    all_tags: All
    annotated_file: Annotated file
    annotations: Annotations
    api_key: API key
    authors: Authors
    bg_color: Background color
    chart: Chart
    columns: Columns
    counter_data_export: Data export in COUNTER format
    counter_version: COUNTER version
    coverage: Coverage
    created: Created
    credentials: Credentials
    custom: Custom
    customer_id: Customer ID
    data_export: Data export
    date: Date
    date_range: Date range
    delete_all_platform_data: Delete all platform data
    delete_data: Delete data
    description: Description
    dimensions: Dimensions
    email: Email
    empty_value: "- empty -"
    error: Error
    export: Export
    exported_data: Exported data
    extra_params: Extra parameters
    file_format: File format
    file_size: File size
    filter_by_tag: Filter by tag
    filter_by_tag_class: Filter by tag class
    filter_settings: Filter settings
    filters: Filters
    finished: Finished
    first_name: First name
    fiscal_year_start_month: First month of fiscal year
    group_by_class: Group by class
    http_authentication: HTTP authentication
    http_password: Password
    http_username: Username
    item: Item
    items: Items
    last_name: Last name
    last_updated_by: Last updated by
    loading: Loading
    metadata: Metadata
    metric: Metric
    months: Months
    new_menu_item: new
    beta_menu_item: beta
    new_tag: New tag
    new_tag_class: New tag class
    no_tags: Click edit to add a tag.
    no_tags_available: No tags available
    off: Off
    on: On
    organization: Organization
    overlap: Overlap
    overridden_dates: Date override
    overridden_organization: Organization override
    parent_title: Parent title | Parent titles
    platform: Platform
    platform_filter: Platform filter
    position: Position
    preview: Preview
    potential_issues: Potential issues
    provider: Provider
    publication_date: Publication date
    relative: Relative
    report_name: Report name
    report_output: Report output
    report_type: Report type
    report_view: Report
    requestor_id: Requestor ID
    rows: Rows
    run_report: Run report
    search: Search
    select_command: Select command
    select_report: Select report
    settings: Settings
    show_class: Show class
    source: Source
    source_file: Source file
    state: State
    status: Status
    tag: Tag
    tag_can_assign: Who can assign tag
    tag_can_see: Who can see tag
    tag_class: Tag class
    tag_class_can_create_tags: Who can add new tags of this class
    tag_class_can_modify: Who can modify this tag class
    tag_class_name: Tag class name
    tag_color: Tag color
    tag_exclusive_already_present: Target already has a tag from the same exclusive class
    tag_description: Tag description
    tag_is_exclusive: Exclusive
    tag_is_exclusive_tt: Only one tag from an exclusive tag class may be assigned to an object
    tag_name: Tag name
    tag_roll_up: Merge rows by tag
    tag_scope: Tag scope
    tag_scope_hint: What type of object can this tag be assigned to
    tags: Tags
    tags_title: Title tags
    tags_platform: Platform tags
    tags_organization: Organization tags
    text_color: Text color
    title: Title / database
    title_count: Title count
    title_count_short: Title count
    today: today
    total: Total
    total_coverage: Total coverage
    unread_messages: Unread messages
    url: URL
    user: User
    username: Username
    value: Value
    variable: Parameter name
    variable_value: Parameter value
    year: Year
    year_and_month: Year and month
  no_reports_available_for_title: No views are defined for the selected data
  no_chart_types_available: There are no charts available for this report type
  type_of_report: Type of report
  interests:
    title: Interest in titles
    database: Interest in databases
    other: Other interest types
    denial: Denied interest
  interest_types: Types of interest to show
  actions:
    add_tag: Add tag
    apply: Apply
    assign_tag: Assign tag
    assign_tags: Assign tags
    cancel: Cancel
    clear_selection: Clear selection
    close: Close
    create: Create
    delete: Delete
    download: Download
    edit: Edit
    override_dates: Override dates
    override_organizations: Override organizations
    proceed: Proceed
    refresh: Refresh
    reharvest: Reharvest
    save: Save
    save_changes: Save changes
    save_as: Save as
    save_report: Save report
    select_all: Select all
    show_attempts: Downloads
    show_chart: Show charts
    show_overview: Overview
    show_overview_details: Yearly overview of downloaded data
    show_raw_data: Show raw data
    start_harvesting: Start harvesting
    start_test: Start test
    upload_data: Upload data
    upload_file: Upload file
    upload_file_for_annotation: Upload file for annotation
  in_czech: Czech
  in_english: English
  cover_image: Cover image
  interest: Interest
  charts: Charts
  celus_version: CELUS version
  warnings:
    select_one_title_type: Select at least one publication type
    saved_with_organization_filter: This report will be saved with organization filter.
    saved_without_current_organization: This report was saved with data from another organization.
    saved_without_current_organization_detail: You can save it as a new report to see data from your organization.
    organization_filter_pruned: Some organizations from the saved report are unavailable.
    organization_filter_pruned_detail: The organization filter was adjusted to match your current organization.
    organization_filter_pruned_detail_limited: You can see data only for your organization.
    organization_tag_filter_pruned: Some organization tags from the saved report are unavailable.
    organization_tag_filter_pruned_detail: The organization tag filter was adjusted to match your current organization.
  blank_value: -- blank --
  tag_access_level:
    everybody: Everybody
    org_users: Organization users
    org_admins: Organizations admins
    cons_admins: Consortium admins
    owner: Only you
    system: System
  tagging:
    data_rows: Data rows
    data_rows_tt: Total number of rows found in the source file
    matched_rows: Matched rows
    matched_rows_tt: Number of rows that matched at least one title
    matched_titles: Matched titles
    matched_celus_titles: Matched CELUS titles
    matched_titles_tt: Total number of unique matched titles
    title_number_note: One row may match more than one title, so this number may be higher than the number of matched rows
    tagged_titles: Tagged titles
    tagged_celus_titles: Tagged CELUS titles
    tagged_titles_tt: Total number of tagged titles.
    total_tagged_titles_tt: Total number of tagged titles across all repetitions.
    tagged_titles_note: This number may be lower than the number of matched titles, because some titles may have already been tagged with the same or a clashing exclusive tag.
    actually_tagged_celus_titles: Actually tagged CELUS titles
    no_match_rows: Rows without match
    no_match_rows_tt: The number of rows which did not match any title
    already_tagged_titles: Already tagged titles
    already_tagged_celus_titles: Already tagged CELUS titles
    already_tagged_titles_tt: Number of titles which had already been tagged with the selected tag
    exclusively_tagged_titles: Exclusively tagged titles
    exclusively_tagged_celus_titles: Exclusively tagged CELUS titles
    exclusively_tagged_titles_tt: Number of titles which had already been tagged with a clashing exclusive tag
    recognized_columns: Recognized columns
    recognized_columns_tt: Names of columns from the uploaded sheet which were recognized as containing title identifiers
    no_recognized_columns: No columns were recognized as containing title identifiers
    create_new_title_list: Upload a new list
    title_list: Title list
    preprocessing_data: Preprocessing
    annotated_source_file: Annotated source file
    annotated_source_file_tt: Copy of the source file annotated with information about identified titles. Use it to review what exactly was matched.
    delete_batch_text: Do you really want to delete the title list? All assigned tags will be removed together with the list itself.
    batch_delete_success: Title list was successfully deleted
    unassign_tag: Unassign tag
    unassign_tag_tt: Unassign tag from all titles in the list
    reassign_tag: Reassign tag
    reassign_tag_tt: Process the title list once again and tag newly matched titles
    tag_stats: Found tags
    tags_read_from_file: Tags are read from file
    show_only_my: Show only my own
    multi_import_tt: This title list was re-imported multiple times. Statistics show the results of the most recent import.
    imports: Imports
    import_count: Import count
    import_count_tt: A title list may be imported multiple times to assign tags to newly arrived titles. This number shows the total number of imports.
    manage: Manage title list - process, undo, re-apply tags
    automatic_reprocessing: Automatic regular re-processing
    automatic_reprocessing_tt: If enabled, the title list will be re-processed automatically each 30 days to assign tags to newly arrived titles.
  tag_state:
    initial: Just uploaded
    preprocessing: Preprocessing
    preflight: Ready for tagging
    prefailed: Preprocessing failed
    failed: Processing failed
    importing: Tagging in progress
    imported: Tag assigned
    undoing: Unassigning tags
    no_matched_titles: No matched titles
  release:
    bug_fix: Bug fix
    new_feature: New feature
    update: Update
    changelog: Full changelog
    version: Version {number}
    bug_fix_tt: This releases contains bug fixes
    new_feature_tt: This release contains new features
    update_tt: This release contains updates of existing features
  registry_info: COUNTER registry info
  events:
    date: Date
    importance: Importance
    title: Title
    category: Category
    read: Read
    expires: Expires
    expires_tt: The event will be automatically removed after this date
    mark_as_read: Mark as read
  event_importance:
    10: Normal
    20: High
  event_category:
    general: General announcements
    overlap: Overlap
    platform: Platform info
    sushi: SUSHI
    tags: Tags
  event_category_desc:
    general: General announcements about CELUS - new releases, planned maintenance, etc.
    overlap: Messages related to overlap analysis
    platform: Alerts about platforms - issues with SUSHI harvesting, data consistency, etc.
    sushi: Messages related to individual SUSHI harvests, such as errors, warnings, etc.
    tags: Messages related to tags - title list imports, tag assignments, etc.
  event_read:
    read: Read
    unread: Unread
    all: All
  event_handling:
    ignore: Ignore
    notify: Notify in app
    email: Send email
  event_handling_desc:
    ignore: Such events will be completely ignored
    notify: A message will be displayed in the app
    email: An email will be sent to you and the event will be displayed in the app
  notifications:
    notifications_enabled: Notifications enabled
    notifications_enabled_tt: System notifications are enabled. To disable them, you need to disable them in your browser settings.
    notifications_disabled: Notifications disabled
    notifications_disabled_tt: System notifications are disabled. To enable them, you need to unblock them in your browser settings first.
    enable_notifications: Enable notifications
    enable_notifications_tt: Enable system notifications. You will be notified about new events even if you are not currently using CELUS.
  errors:
    file_too_large: The uploaded file is too large
    error_start_after_end: Start date must precede end date.
  options:
    all: All
  overlap_analysis:
    loading_data: "Please wait while CELUS is crunching the data for you. It has to go over all the titles and that takes some time."

cs:
  pages:
    account_management: Správa účtů
    admin: Administrace
    all_titles: Všechny tituly
    analytics: Analytické nástroje
    ch_export: Data Hub
    anomaly_report: Anomálie v datech
    changelog: Seznam změn
    configuration: Konfigurace
    content: Obsah
    create_report: Vytvořit report
    dashboard: Přehled
    data_coverage_overview: Přehled pokrytí daty
    data_management: Správa dat
    event_preferences: Nastavení událostí
    events: Události
    exports: Exporty
    flexi_report: Detail report
    flexi_reports: Reporty
    flexitable: Reporting a exporty
    heatmap: Heatmapa zájmu
    import_batches: Importované dávky
    interest_overview: Nastavení zájmu
    item_detail: Detail položky
    maintenance: Údržba
    management: Management
    management_commands: Management příkazy
    manual_data_uploads: Ručně nahraná data
    mdu_detail: Detail ručně nahraných dat
    organization_administration: Správa organizace
    organizations: Organizace
    overlap_analysis_platforms: Překryv platforem
    overlap_analysis_titles: Tituly na více platformách
    platform_detail: Detail platformy
    platforms: Platformy
    releases: Verze
    settings: Nastavení
    specialized_reports: Speciální reporty
    subscriptions: Analýza překryvů
    supported_non_counter_platforms: non-SUSHI platformy
    sushi: SUSHI
    sushi_fetch_attempts: Stahování SUSHI
    sushi_management: Správa SUSHI
    sushi_monthly_overview: Stav SUSHI
    sushi_troubleshooting: Řešení problémů
    tag_management: Správa štítků
    tags: Štítky
    tags_title: Štítky titulu
    tags_platform: Štítky platformy
    tags_organization: Štítky organizace
    title_detail: Detail titulu
    title_list_overlap: Překryv titulového seznamu
    title_lists: Titulové seznamy
    user_page: Uživatelská stránka
    whats_new: Co je nového
    user_management: Správa uživatelů
    counter_registry: COUNTER Registr
  menu: Menu
  organization: Organizace
  platform: Platforma
  title: Titul
  report: Report
  month: Měsíc
  year: Rok
  title_fields:
    access_level: Viditelnost
    actions: Akce
    active_reports: Aktivní reporty
    contains_data: Obsahuje data
    counter_version: Verze COUNTER
    created: Vytvořeno
    data_coverage: Pokrytí daty
    data_file: Datový soubor
    doi: DOI
    download_success: Úspěšné stažení
    eissn: eISSN
    enabled: Zapnuto
    end_date: Koncové datum
    error_code: Kód chyby
    id: ID
    info: Informace
    isbn: ISBN
    issn: ISSN
    knowledgebase: Znalostní báze
    last_modified: Naposledy změněno
    last_modified_by: Naposledy změněno uživatelem
    lock: Zámek
    log: Log
    name: Název
    non_counter: Non-COUNTER
    not_before: Stažení nejdříve
    organizations: Organizace
    outside_consortium: Mimo konzorcium
    platform_count: Počet platforem
    platforms: Platformy
    primary_dimension: Řádky
    primary_dimensions: Řádky
    processed: Importováno
    processing_success: Úspěšné zpracování
    proprietary_ids: Interní ID
    proprietary_ids_tt: Interní identifikátory titulu u jednotlivých platformem/vydavatelů
    publication_date: Datum vydání
    queued: Odloženo
    ratios: Rozložení
    report_types: Typy reportů
    reports: Reporty
    select_platform: Vyberte platformu
    short_name: Krátký název
    split_by: Rozdělit podle
    start_date: Počáteční datum
    status: Stav
    success: Úspěch
    total_interest: Celkový zájem
    type: Typ
    uploaded: Nahráno
  titles: Tituly
  overview: Přehled
  chart:
    count: Počet
  date_range:
    all_available: Vše dostupné
    current_plus_1y_back: Tento a předchozí rok
    current_plus_2y_back: Tento a dva předchozí roky
    custom: Vlastní
    last_2_closed_fy: Poslední dva uzavřené fiskální roky
    last_12_mo: Posledních 12 měsíců
    last_closed_fy: Poslední uzavřený fiskální rok
    ongoing_and_previous_fy: Probíhající a předchozí fiskální rok
    ongoing_fy: Probíhající fiskální rok
    previous_2_years: Předchozí dva kalendářní roky
    previous_year: Předchozí kalendářní rok
    current_year: Aktuální rok
  date_range_desc:
    current_plus_2y_back: Odpovídá retenční periodě pro COUNTER data
    custom: Manuální volba zobrazeného období
  labels:
    accesslog_count: Počet záznamů
    all_tags: Všechny
    annotated_file: Anotovaný soubor
    annotations: Poznámky
    authors: Autoři
    api_key: API key
    bg_color: Barva pozadí
    chart: Graf
    columns: Sloupce
    counter_data_export: Export dat v COUNTER formátu
    counter_version: Verze COUNTER
    coverage: Pokrytí
    created: Datum vytvoření
    credentials: Přihlašovací údaje
    custom: Vlastní
    customer_id: Customer ID
    data_export: Export dat
    date: Datum
    date_range: Rozmezí dat
    delete_all_platform_data: Smazat všechna data pro platformu
    delete_data: Mazání dat
    description: Popis
    dimensions: Dimenze
    email: Email
    empty_value: "- prázdné -"
    error: Chyba
    export: Exportovat
    exported_data: Exportovaná data
    extra_params: Další parametry
    file_format: Formát souboru
    file_size: Velikost souboru
    filter_by_tag: Filtrovat podle štítku
    filter_by_tag_class: Filtrovat podle typu štítku
    filter_settings: Nastavení filtrů
    filters: Filtry
    finished: Dokončeno
    first_name: Jméno
    fiscal_year_start_month: První měsíc fiskálního roku
    group_by_class: Seskupit podle typu
    http_authentication: HTTP autentizace
    http_password: Heslo
    http_username: Uživatelské jméno
    item: Položka
    items: Položky
    last_name: Příjmení
    last_updated_by: Naposledy upravil
    loading: Načítání
    metadata: Metadata
    metric: Metrika
    months: Měsíce
    new_menu_item: novinka
    beta_menu_item: beta
    new_tag: Nový štítek
    new_tag_class: Nový typ štítku
    no_tags: Klikněte na editaci k přidání štítku.
    no_tags_available: Nejsou dostupné žádné štítky
    off: vypnuto
    on: Zapnuto
    organization: Organizace
    overlap: Překryv
    overridden_dates: Přepsané období
    overridden_organization: Přepsaná organizace
    parent_title: Nadřazený titul | Nadřazené tituly
    platform: Platforma
    platform_filter: Filtr platformy
    position: Pozice
    preview: Náhled
    provider: Poskytovatel
    publication_date: Datum publikace
    relative: Relativně
    report_name: Jméno reportu
    report_output: Výstup reportu
    report_type: Typ reportu
    report_view: Report
    requestor_id: Requestor ID
    rows: Řádky
    run_report: Spustit report
    search: Vyhledávání
    select_command: Vyberte příkaz
    select_report: Vyberte report
    settings: Nastavení
    show_class: Zobrazit typ
    source: Zdroj
    source_file: Zdrojový soubor
    state: Stav
    status: Stav
    tag: Štítek
    tag_can_assign: Kdo může štítek přiřazovat
    tag_can_see: Kdo štítek uvidí
    tag_class: Typ štítku
    tag_class_can_create_tags: Kdo může vytvářet štítky v této skupině
    tag_class_can_modify: Kdo může upravovat typ štítku
    tag_class_name: Název typu štítku
    tag_color: Barva štítku
    tag_exclusive_already_present: Štítek stejného exklusivního typu je již přítomen
    tag_description: Popis štítku
    tag_is_exclusive: Exklusivní
    tag_is_exclusive_tt: Objektu může být přiřazený jenom jeden štítek ze skupiny, pokud je typ označný jako exklusivní
    tag_name: Název štítku
    tag_roll_up: Sloučit řádky podle štítků
    tag_scope: Cíl štítku
    tag_scope_hint: K jakému typu objektu může být štítek připojen
    tags: Štítky
    text_color: Barva textu
    title: Titul / databáze
    title_count: Počet titulů a databází
    title_count_short: Počet titulů
    today: dnes
    total: Celkem
    total_coverage: Celkové pokrytí
    unread_messages: Nepřečtené zprávy
    url: URL
    user: Uživatel
    username: Uživatelské jméno
    value: Hodnota
    variable: Název parametru
    variable_value: Hodnota parametru
    year: Rok
    year_and_month: Rok a měsíc
  no_reports_available_for_title: Nejsou dostupné žádné pohledy na zvolená data
  no_chart_types_available: Pro tento typ zprávy nejsou k dispozici žádné grafy
  type_of_report: Typ reportu
  interests:
    title: Zájem o tituly
    database: Zájem o databáze
    other: Další typy zájmu
    denial: Odepřený zájem
  interest_types: Zobrazené typy zájmu
  actions:
    add_tag: Přidat štítek
    apply: Aplikovat
    assign_tag: Oštítkovat
    assign_tags: Oštítkovat
    cancel: Zrušit
    clear_selection: Zrušit výběr
    close: Zavřít
    create: Vytvořit
    delete: Smazat
    download: Stáhnout
    edit: Editovat
    override_dates: Přepsat období
    override_organizations: Přepsat organizace
    proceed: Provést
    refresh: Aktualizovat
    reharvest: Znovu stáhnout
    save: Uložit
    save_changes: Uložit změny
    save_report: Uložit report
    save_as: Uložit jako
    select_all: Vybrat vše
    show_attempts: Stažení
    show_chart: Zobrazit grafy
    show_overview: Přehled
    show_overview_details: Roční přehled stažených dat
    show_raw_data: Zobrazit data
    start_harvesting: Spustit stahování
    start_test: Spustit test
    upload_data: Nahrát data
    upload_file: Nahrát soubor
    upload_file_for_annotation: Nahrát soubor pro anotaci
  in_czech: česky
  in_english: anglicky
  cover_image: Obrázek obálky
  interest: Zájem
  charts: Grafy
  celus_version: CELUS verze
  warnings:
    select_one_title_type: Vyberte alespoň jeden typ publikace
    saved_with_organization_filter: Tento report bude uložen s filtrem organizací.
    saved_without_current_organization: Tento report byl uložen s daty z jiné organizace.
    saved_without_current_organization_detail: Můžete jej uložit jako nový report a zobrazit data z vaší organizace.
    organization_filter_pruned: Některé organizace z uloženého reportu nejsou k dispozici.
    organization_filter_pruned_detail: Filtr organizací byl upraven podle vaší aktuální organizace.
    organization_filter_pruned_detail_limited: Můžete vidět data pouze pro vaši organizaci.
    organization_tag_filter_pruned: Některé tagy organizací z uloženého reportu nejsou k dispozici.
    organization_tag_filter_pruned_detail: Filtr tagů organizací byl upraven podle vaší aktuální organizace.
  blank_value: -- prázdná hodnota --
  tag_access_level:
    everybody: Kdokoli
    org_users: Členové organizace
    org_admins: Administrátoři organizace
    cons_admins: Administrátoři konzorcia
    owner: Pouze vy
    system: Systém
  tagging:
    data_rows: Datové řádky
    data_rows_tt: Celkový počet řádků nalezených ve zdrojovém souboru
    matched_rows: Nalezené řádky
    matched_rows_tt: Počet řádků, které našly alespoň jeden titul
    matched_titles: Nalezené tituly
    matched_celus_titles: Nalezené CELUS tituly
    matched_titles_tt: Počet unikátních identifikovaných titulů
    title_number_note: Jeden řádek může odpovídat více titulům. Je tedy možné, že toto číslo bude větší než počet identifikovaných řádků.
    tagged_titles: Oštítkované tituly
    tagged_celus_titles: Oštítkované CELUS tituly
    tagged_titles_tt: Celkový počet oštítkovaných titulů.
    total_tagged_titles_tt: Celkový počet oštítkovaných titulů napříč všemi opakováními.
    tagged_titles_note: Toto číslo může být menší než počet identifikovaných titulů, pokud byly některé tituly již oštítkovány stejným nebo kolidujícím exkluzivním štítkem.
    actually_tagged_celus_titles: Skutečně oštítkované CELUS tituly
    no_match_rows: Řádky bez odpovídajícího titulu
    no_match_rows_tt: Počet řádků, které neodpovídají žádnému titulu v databázi
    already_tagged_titles: Již dříve oštítkované tituly
    already_tagged_celus_titles: Již dříve oštítkované CELUS tituly
    already_tagged_titles_tt: Počet titulů, které odpovídají nahranému souboru, ale byly již dříve označeny stejným štítkem
    exclusively_tagged_titles: Exklusivně oštítkované tituly
    exclusively_tagged_celus_titles: Exklusivně oštítkované CELUS tituly
    exclusively_tagged_titles_tt: Počet titulů, které odpovídají nahranému souboru, ale byly již dříve označeny jiným exklusivním štítkem
    recognized_columns: Rozeznané sloupce
    recognized_columns_tt: Názvy sloupců z nahrané tabulky, které byly rozeznány jako použitelné pro identifikaci titulů
    no_recognized_columns: Nebyl nalezen žádný sloupec s identifikátory
    create_new_title_list: Nahrát nový seznam
    title_list: Seznam titulů
    preprocessing_data: Probíhá předzpracování
    annotated_source_file: Anotovaný zdrojový soubor
    annotated_source_file_tt: Kopie zdrojového souboru doplněná o informace o identifikovaných titulech.
    delete_batch_text: Opravdu si přejete smazat tento seznam titulů? Všechny přiřazené štítky odstraněny spolu se samotným seznamem.
    batch_delete_success: Seznam titulů byl úspěšně smazán
    unassign_tag: Odstranit štítky
    unassign_tag_tt: Odstraní odpovídající štítky z nalezených titulů
    reassign_tag: Opakovat přiřazení
    reassign_tag_tt: Zpracuje seznam titulů znovu a přiřadí štítky nově nalezeným titulům
    tag_stats: Nalezené štítky
    tags_read_from_file: Štítky jsou načteny ze souboru
    show_only_my: Zobrazit jen moje
    multi_import_tt: Tento seznam titulů byl nahrán vícekrát. Statistiky zobrazují výsledky nejnovějšího importu.
    imports: Importy
    import_count: Počet importů
    import_count_tt: Seznam titulů může být opakovaně nahrán, aby došlo k přiřazení štítků k novým titulům. Toto číslo zobrazuje celkový počet importů.
    manage: Správa seznamu titulů - zpracování, odstranění štítků, opětovné přiřazení štítků
    automatic_reprocessing: Automatické pravidelné zpracování
    automatic_reprocessing_tt: Pokud je zapnuto, seznam titulů bude vždy po 30 dnech automaticky zpracován, aby byly přiřazeny štítky k novým titulům.
  tag_state:
    initial: Právě nahráno
    preprocessing: Probíhá předzpracování
    preflight: Připraveno k štítkování
    prefailed: Předzpracování selhalo
    failed: Zpracování selhalo
    importing: Probíhá štítkování
    imported: Štítkování dokončeno
    undoing: Odstraňování štítků
    no_matched_titles: Žádné odpovídající tituly
  release:
    bug_fix: Oprava chyby
    new_feature: Nová funkce
    update: Aktualizace
    changelog: Úplný seznam změn
    version: Verze {number}
    bug_fix_tt: Toto vydaní obsahuje opravy chyb
    new_feature_tt: Toto vydaní obsahuje nové funkce
    update_tt: Toto vydaní obsahuje aktualizace existujících funkcí
  registry_info: Informace z COUNTER registru
  events:
    date: Datum
    importance: Důležitost
    title: Titul
    category: Kategorie
    read: Přečteno
    expires: Expiruje
    expires_tt: Po uplynití tohoto data bude událost automaticky odstraněna
    mark_as_read: Označit jako přečtené
  event_importance:
    10: Normální
    20: Vysoká
  event_category:
    general: Obecné oznámení
    overlap: Překryv
    platform: Informace o platformě
    sushi: SUSHI
    tags: Štítky
  event_category_desc:
    general: Obecné oznámení o CELUSu - nové verze, plánovaná údržba, atd.
    overlap: Zprávy související s analýzou překryvů
    platform: Upozornění o platformách - problémy se stahováním SUSHI, konzistencí dat, atd.
    sushi: Zprávy související s jednotlivými stahováními SUSHI, jako jsou chyby, varování, atd.
    tags: Zprávy související se štítky - importy seznamů titulů, přiřazení štítků, atd.
  event_read:
    read: Přečteno
    unread: Nepřečteno
    all: Všechny
  event_handling:
    ignore: Ignorovat
    notify: Zpráva v aplikaci
    email: Poslat e-mail
  event_handling_desc:
    ignore: Takové události budou zcela ignorovány
    notify: V aplikaci bude zobrazena zpráva
    email: E-mail bude odeslán vám a událost bude zobrazena v aplikaci
  notifications:
    notifications_enabled: Notifikace zapnuty
    notifications_enabled_tt: Systémové notifikace jsou zapnuty. Pro jejich vypnutí je potřeba je vypnout v nastavení prohlížeče.
    notifications_disabled: Notifikace vypnuty
    notifications_disabled_tt: Systémové notifikace jsou vypnuty. Pro jejich zapnutí je potřeba odstranit jejich blokaci v nastavení prohlížeče.
    enable_notifications: Zapnout notifikace
    enable_notifications_tt: Zapnout systémové notifikace. Budete upozorněni na nové události i když právě nepoužíváte CELUS.
  errors:
    file_too_large: Nahrávaný soubor je příliš velký
    error_start_after_end: Počáteční datum musí být před koncovým datem.
  options:
    all: Všechny
  overlap_analysis:
    loading_data: "Prosíme o chvilku strpení, než CELUS přechroupe data. Musí zpracovat záznamy o všech titulech a to nějakou dobu zabere."
